import { Form } from './form';
import { Config } from '../config';
import { Order } from '../config/order';
import { FormTypes } from './form-types';
import { GoogleAnalyticsView } from '../view/google-analytics-view';
import { OrderItem } from '../config/order-item';
import { Discount } from '../config/discount';

export class GoogleAnalyticsForm extends Form {

    type = FormTypes.GoogleAnalytics;
    view: GoogleAnalyticsView = new GoogleAnalyticsView();

    constructor() {
        super();
    }

    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
    }

    async render() {
        this.view.render(this.config.analytics.googleAnalyticsId);
        return Promise.resolve();
    }

    submit(order: Order) {
        return Promise.resolve(order);
    }

    postSubmit(submissionContext: any): Promise<any> {
        this.sendPurchaseEvent(submissionContext);
        return Promise.resolve();
    }

    sendPurchaseEvent = (submissionContext: any) => {
        const gtag = this.view.getGtagInstance();
        gtag(
            'event',
            'purchase',
            {
                transaction_id: submissionContext?.result?.orderId || null,
                value: this.config.widget.totalAmount,
                currency: this.config.settings.currency,
                items: this.getPurchaseItems(submissionContext.orderItems),
                tax: submissionContext.taxAmount || 0
            }
        );
    }

    getPurchaseItems(orderItems: OrderItem[]) {
        const purchaseItems: any[] = [];
        orderItems.forEach((orderItem: OrderItem, index: Number) => {
            purchaseItems.push(
                {
                    index: index,
                    item_id: orderItem.dfProductId || null,
                    item_name: orderItem.productName,
                    currency: this.config.settings.currency,
                    price: orderItem.amount || 0,
                    quantity: orderItem.quantity || 1,
                    coupon: this.getPurchaseCoupon(orderItem),
                    discount: this.getPurchaseDiscountAmount(orderItem)
                }
            );
        });
        return purchaseItems;
    }

    getPurchaseCoupon = (orderItem: OrderItem) => {
        const discount = this.findDiscount(orderItem);
        if (discount == null) {
            return null;
        }
        return discount.code || discount.id || null;
    }

    getPurchaseDiscountAmount = (orderItem: OrderItem) => {
        const discount = this.findDiscount(orderItem);
        return discount !== null ? this.config.widget.calcDiscount(orderItem.amount, discount) : 0;
    }

    findDiscount = (orderItem: OrderItem) => {
        const discountId = orderItem.discountId || orderItem.couponId;
        if (!discountId) {
            return null;
        }
        const discountForm = this.config.widget.getDiscountForm();
        if (!discountForm) {
            return null;
        }
        const discounts = discountForm.discounts;
        if (discounts === null || discounts.length === 0) {
            return null;
        }
        return discounts.find((discount: Discount) => discount.id === discountId);
    }

}
